export interface Product {
  id: string;
  name: string;
  category: 'business' | 'festival' | 'family';
  price: number;
  originalPrice?: number;
  imageUrl: string;
  description: string;
  features: string[];
  weight: string;
  servings: string;
  packaging: string;
}

export const products: Product[] = [
  {
    id: 'biz-001',
    name: '尊爵商务鲍鱼礼盒',
    category: 'business',
    price: 3888,
    originalPrice: 4588,
    imageUrl: 'https://readdy.ai/api/search-image?query=Premium%20luxury%20dark%20wood%20abalone%20gift%20box%20with%20gold%20trim%20details%20and%20black%20silk%20interior%2C%20elegant%20gourmet%20seafood%20product%20photography%20on%20warm%20cream%20backdrop%2C%20soft%20dramatic%20studio%20lighting%20with%20rich%20shadows%2C%20high%20end%20minimalist%20composition&width=800&height=800&seq=biz-premium-abalone-gift&orientation=squarish',
    description: '精选8头南非干鲍，搭配进口松露油与特制鲍汁，以黑檀木礼盒精装呈现，彰显尊贵商务格调。',
    features: ['8头南非干鲍 x 6', '进口黑松露油 x 1', '秘制鲍汁 x 2', '黑檀木精装礼盒'],
    weight: '净重 1.2kg',
    servings: '6-8人份',
    packaging: '黑檀木礼盒 + 真丝内衬',
  },
  {
    id: 'biz-002',
    name: '领航者商务套装',
    category: 'business',
    price: 5888,
    originalPrice: 6888,
    imageUrl: 'https://readdy.ai/api/search-image?query=Luxury%20leather%20double%20layer%20abalone%20gift%20set%20with%20gold%20foil%20details%20and%20velvet%20interior%2C%20premium%20Japanese%20dried%20abalone%20display%2C%20elegant%20dark%20brown%20leather%20box%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20high%20end%20food%20gift%20composition&width=800&height=800&seq=biz-leader-abalone-set&orientation=squarish',
    description: '顶级12头日本吉品鲍，配以金箔鲍汁与陈年花雕酒，双层皮质礼盒，专为高端商务馈赠打造。',
    features: ['12头日本吉品鲍 x 8', '金箔秘制鲍汁 x 2', '陈年花雕酒 x 1', '双层皮质精装礼盒'],
    weight: '净重 1.8kg',
    servings: '8-10人份',
    packaging: '双层皮质礼盒 + 天鹅绒内衬',
  },
  {
    id: 'biz-003',
    name: '臻品商务鲍鱼篮',
    category: 'business',
    price: 2688,
    originalPrice: 3288,
    imageUrl: 'https://readdy.ai/api/search-image?query=Handwoven%20rattan%20basket%20with%20premium%20Australian%20green%20lip%20abalone%20and%20red%20wine%20gift%20set%2C%20silk%20ribbon%20decorated%20gourmet%20seafood%20hamper%2C%20elegant%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20natural%20studio%20lighting%2C%20high%20end%20food%20photography&width=800&height=800&seq=biz-premium-basket&orientation=squarish',
    description: '精选6头澳洲青边鲍，搭配高山茶叶与精品红酒，藤编礼篮设计，商务往来体面之选。',
    features: ['6头澳洲青边鲍 x 4', '高山铁观音 x 1', '进口红酒 x 1', '手工藤编礼篮'],
    weight: '净重 2.0kg',
    servings: '4-6人份',
    packaging: '手工藤编礼篮 + 绸缎内衬',
  },
  {
    id: 'fest-001',
    name: '新春贺岁鲍鱼礼盒',
    category: 'festival',
    price: 1688,
    originalPrice: 1988,
    imageUrl: 'https://readdy.ai/api/search-image?query=Chinese%20New%20Year%20red%20and%20gold%20abalone%20gift%20box%20with%20traditional%20auspicious%20patterns%2C%20festive%20luxury%20seafood%20gift%20set%20with%20gold%20inner%20lining%2C%20elegant%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20high%20end%20holiday%20food%20photography&width=800&height=800&seq=fest-spring-abalone&orientation=squarish',
    description: '喜庆中国红礼盒，精选6头鲜鲍，搭配年糕与腊味，新春佳节馈赠亲友的上佳之选。',
    features: ['6头鲜鲍 x 6', '手工年糕 x 2', '广式腊肠 x 1', '中国红精装礼盒'],
    weight: '净重 1.5kg',
    servings: '6-8人份',
    packaging: '中国红礼盒 + 金色内衬',
  },
  {
    id: 'fest-002',
    name: '中秋团圆鲍鱼套装',
    category: 'festival',
    price: 1288,
    originalPrice: 1588,
    imageUrl: 'https://readdy.ai/api/search-image?query=Mid%20Autumn%20festival%20moon%20theme%20abalone%20and%20mooncake%20gift%20box%20with%20silk%20interior%2C%20elegant%20dark%20blue%20and%20gold%20packaging%20with%20moon%20motif%2C%20luxury%20seafood%20gift%20set%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting&width=800&height=800&seq=fest-mid-autumn&orientation=squarish',
    description: '月圆人团圆，精选8头鲜鲍搭配精品月饼与桂花酿，中秋送礼典雅大方。',
    features: ['8头鲜鲍 x 4', '精品月饼 x 4', '桂花陈酿 x 1', '月圆主题精装礼盒'],
    weight: '净重 1.3kg',
    servings: '4-6人份',
    packaging: '月圆主题礼盒 + 丝绸内衬',
  },
  {
    id: 'fest-003',
    name: '端午安康鲍鱼礼篮',
    category: 'festival',
    price: 988,
    originalPrice: 1288,
    imageUrl: 'https://readdy.ai/api/search-image?query=Dragon%20Boat%20festival%20themed%20bamboo%20woven%20gift%20basket%20with%20abalone%20and%20traditional%20rice%20dumplings%2C%20green%20bamboo%20decorated%20luxury%20seafood%20hamper%2C%20elegant%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20high%20end%20food%20photography&width=800&height=800&seq=fest-dragon-boat&orientation=squarish',
    description: '端午时节，以鲜美鲍鱼搭配传统粽子与雄黄酒，传递安康祝福的精致礼篮。',
    features: ['6头鲜鲍 x 4', '手工粽子 x 6', '陈年雄黄酒 x 1', '端午主题精装礼篮'],
    weight: '净重 1.2kg',
    servings: '4-6人份',
    packaging: '端午主题礼篮 + 竹编装饰',
  },
  {
    id: 'fam-001',
    name: '家宴尊享鲍鱼套装',
    category: 'family',
    price: 888,
    imageUrl: 'https://readdy.ai/api/search-image?query=Family%20style%20abalone%20cooking%20gift%20set%20with%20sauce%20and%20recipe%20book%20in%20clean%20modern%20packaging%2C%20fresh%20seafood%20meal%20kit%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20elegant%20minimalist%20food%20photography&width=800&height=800&seq=fam-feast-set&orientation=squarish',
    description: '为家庭聚餐精心搭配，10头鲜鲍搭配鲍汁调味料，简单烹饪即可享受星级家宴。',
    features: ['10头鲜鲍 x 8', '秘制鲍汁 x 2', '烹饪指南 x 1', '简约精装礼盒'],
    weight: '净重 1.0kg',
    servings: '4-6人份',
    packaging: '简约精装礼盒',
  },
  {
    id: 'fam-002',
    name: '鲜享家庭鲍鱼组合',
    category: 'family',
    price: 588,
    originalPrice: 688,
    imageUrl: 'https://readdy.ai/api/search-image?query=Affordable%20family%20abalone%20and%20sea%20cucumber%20combo%20gift%20box%20with%20fresh%20packaging%2C%20everyday%20premium%20seafood%20set%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20clean%20and%20elegant%20food%20photography&width=800&height=800&seq=fam-fresh-combo&orientation=squarish',
    description: '经济实惠的家庭组合，12头鲜鲍搭配海参，营养丰富，全家共享海鲜盛宴。',
    features: ['12头鲜鲍 x 6', '即食海参 x 4', '鲍汁调味包 x 2', '保鲜精装礼盒'],
    weight: '净重 0.8kg',
    servings: '3-4人份',
    packaging: '保鲜精装礼盒',
  },
  {
    id: 'fam-003',
    name: '轻奢家庭鲍鱼体验装',
    category: 'family',
    price: 388,
    imageUrl: 'https://readdy.ai/api/search-image?query=Entry%20level%20abalone%20tasting%20gift%20set%20with%20classic%20sauce%20in%20simple%20elegant%20packaging%2C%20accessible%20luxury%20seafood%20product%20photography%20on%20warm%20cream%20background%2C%20soft%20studio%20lighting%2C%20minimalist%20high%20end%20food%20photography&width=800&height=800&seq=fam-light-luxury&orientation=squarish',
    description: '入门级家庭体验装，8头鲜鲍搭配经典调味，让日常餐桌也能品味高端海鲜。',
    features: ['8头鲜鲍 x 4', '经典鲍汁 x 1', '烹饪食谱 x 1', '简约保鲜包装'],
    weight: '净重 0.5kg',
    servings: '2-3人份',
    packaging: '简约保鲜包装',
  },
];

export const categoryInfo = {
  business: {
    name: '商务送礼',
    icon: 'ri-briefcase-4-line',
    description: '高端商务馈赠之选，彰显品位与诚意',
    keywords: ['商务鲍鱼礼盒', '高端商务送礼', '企业礼品', '客户答谢'],
  },
  festival: {
    name: '节日礼盒',
    icon: 'ri-gift-2-line',
    description: '传统佳节送礼首选，传递美好祝福',
    keywords: ['节日鲍鱼礼品', '春节送礼', '中秋礼盒', '端午伴手礼'],
  },
  family: {
    name: '家庭享用',
    icon: 'ri-home-heart-line',
    description: '为家人打造的海鲜盛宴，品质生活之选',
    keywords: ['家庭鲍鱼套餐', '海鲜家宴', '鲍鱼食材', '家庭海鲜'],
  },
};